<template>
  <div>
    <div>
      <el-button v-if="booking_id_from_query" @click="goBack()" size="small"><i class="fa fa-arrow-left"></i>
        Back</el-button>
      <hr>
    </div>
    <div v-if="!booking && !loading">No trip today</div>
    <div class="row" v-if="booking" v-loading="loading">
      <div class="col-lg-4">
        <el-card>
          <div style="text-align: center;">
            <div style="font-size: 20px;">{{ booking.route.code }}</div>
            <div style="font-size: 30px;font-weight: bold;">{{ booking.booking_date }} / {{ booking.formatted_time }}</div>
            <div style="font-size: 50px;font-weight: bold;" class="text-primary">{{ booking.total_completed_tickets }}
            </div>
            <div>PAX LOAD</div>
            <div>({{ booking.status_label }})</div>
            <hr>
            <el-descriptions title="DETAILS" :column="1">
              <el-descriptions-item label="VESSEL">{{ booking.vessel.name }}</el-descriptions-item>
              <el-descriptions-item label="BOOKED">{{ booking.total_passengers }}</el-descriptions-item>
              <el-descriptions-item label="CHECKED-IN">{{ booking.data.checked_in_tickets }}</el-descriptions-item>

              <el-descriptions-item label="TOTAL CAPACITY">{{ booking.capacity }}</el-descriptions-item>
              <el-descriptions-item label="ONLINE TICKETS">{{ booking.data.online_tickets_count
                }}</el-descriptions-item>

            </el-descriptions>
            <hr>
            <el-descriptions title="ACCOMMODATIONS" :column="1">
              <el-descriptions-item  v-for="(accom, i) in booking.data.accommodations" :key="i">
                <div :class="accom.total_tickets >= accom.capacity ? 'text-red':''">{{ accom.name }} {{ accom.total_tickets }} / {{ accom.capacity }}
                </div>
              </el-descriptions-item>

            </el-descriptions>
            <hr>
          </div>

          <div v-if="create_ticket">
            <ViewIssuedTickets :booking="booking"></ViewIssuedTickets>
            <hr>
          </div>

          <div v-if="create_ticket && selected_accommodation_with_seats">
              <CreateTicketsFromBookingForm :booking="booking" :accommodation="selected_accommodation_with_seats" @remove="handleRemoveSeatFromAccommodation" @refresh="getBooking"></CreateTicketsFromBookingForm>
          </div>
          
        </el-card>
      </div>
      <div class="col-lg-8">
        <div class="" v-if="booking && booking.vessel" style="height: 300px;">
          <vessel-seats-list 
          :vessel="booking.vessel" 
          :booking="booking" 
          :create_ticket="create_ticket"
          :created_ticket_seats="selected_accommodation_with_seats ? selected_accommodation_with_seats.selected_seats : []"
           @selectedSeatsAndAccommodation="handleSelectedSeats"></vessel-seats-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Analytic
} from '@/resources/analytics'

import {
  db
} from '@/firebase'
import VesselSeatsList from '../Vessels/VesselSeatsList.vue'
import CreateTicketsFromBookingForm from './IssueTickets/CreateTicketsFromBookingForm.vue'
import ViewIssuedTickets from './IssueTickets/ViewIssuedTickets.vue'

export default {
  components: { VesselSeatsList, CreateTicketsFromBookingForm, ViewIssuedTickets },
  props: ['create_ticket'],
  data() {
    return {
      booking: null,
      loaded: false,
      loading: false,
      booking_id_from_query: null,
      selected_accommodation_with_seats: null
    }
  },
  created: function () {
    this.booking_id_from_query = this.$route.query.booking_id
    this.getBooking()
  },
  methods: {
    handleRemoveSeatFromAccommodation(seat_number) {      
      this.selected_accommodation_with_seats.selected_seats =  this.selected_accommodation_with_seats.selected_seats.filter(seat => seat !== seat_number);
    },
    handleSelectedSeats(data) {
      this.selected_accommodation_with_seats = Object.assign({}, data)
    },
    getBooking() {
      let form = { complete: true }
      if (this.booking_id_from_query) form.booking_id = this.booking_id_from_query
      this.loading = true
      this.booking = null
      if (this.create_ticket) form.with_prices = true
      this.selected_accommodation_with_seats = null
      Analytic.currentBooking(form)
        .then(result => {
          this.booking = result.data.booking
          if (!this.loaded) this.fetchFromFirebase()
          if (this.create_ticket) this.booking.prices = result.data.prices
        })
        .catch(() => {

        }).finally(() => {
          this.loading = false
        })
    },
    fetchFromFirebase() {
      if (this.create_ticket) return
      var self = this
      let path = 'bookings/' + this.booking.id

      var ref = db.ref(path)

      ref
        .orderByChild('timestamp')
        .limitToLast(1) // Limit to the last record (the latest added)
        .on("child_added", (snapshot) => {
          const item = snapshot.val();
          this.getBooking()
          console.log("Booking updated")

        });

        this.loaded = true
    }
  }
}
</script>

<style lang="scss"></style>
